/**
 * API endpoint configuration
 *
 * This can be set using the REACT_APP_API_ENDPOINT environment variable
 * For production builds, this should be an empty string
 *
 * Default values:
 * - QA: https://qa.usestarfish.com
 * - Production: https://app.usestarfish.com
 */
const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || '';
export default apiEndpoint;
